export const storyboardReportsHeader = [ "Storyboard", "Views", "Leads", "Visitors", "Total Time" ]
export const sessionAnalyticsHeader = [ 
    <th className={"headerData"}>Visitor Details<br /> & Date</th>, 
    <th className="headerData">Storyboard</th>, 
    <th className="headerData">Source, Medium<br /> & Page landed on</th>, 
    <th className="headerData">Geography<br /> & Device</th>, 
    <th className="headerData">Time &<br /> Completion %</th> 
]
export const assetAnalyticsHeader = ["Asset Name", "Storyboard", "Views", "Visitors", "Leads", 'Avg. Time Spent', "Bounce Rate", "Downloads"]

export const leadReportHeader = [
    {
      "name": "First Name",
      "field": "firstName",
      "values": "",
      "uid": "firstName"
    },
    {
      "name": "Last Name",
      "field": "lastName",
      "values": "",
      "uid": "lastName"
    },
    {
      "name": "Email Id",
      "field": "email",
      "values": "",
      "uid": "email"
    },
    {
      "name": "Company",
      "field": "company",
      "values": "",
      "uid": "company"
    },
    {
      "name": "Title",
      "field": "title",
      "values": "",
      "uid": "title"
    },
    {
      "name": "Work Phone",
      "field": "workPhone",
      "values": "",
      "uid": "workPhone"
    },
    {
      "name": "Storyboard",
      "field": "storyboard",
      "values": "",
      "uid": "storyboard"
    },
    {
      "name": "Source",
      "field": "source",
      "values": "",
      "uid": "campaignSource"
    },
    {
      "name": "Medium",
      "field": "medium",
      "values": "",
      "uid": "campaignMedium"
    },
    {
      "name": "Campaign",
      "field": "campaign",
      "values": "",
      "uid": "campaignName"
    },
    {
      "name": "Created Date",
      "field": "createdDate",
      "values": "",
      "uid": "createdDate"
    },
    {
      "name": "Last Visited",
      "field": "lastVisitedDate",
      "values": "",
      "uid": "lastVisitedDate"
    },
    {
      "name": "Views",
      "field": "views",
      "values": "",
      "uid": "views"
    },
    {
      "name": "Time Spent",
      "field": "timeSpent",
      "values": "",
      "uid": "timeSpent"
    },
    {
      "name": "Completion %",
      "field": "completion",
      "values": "",
      "uid": "completion"
    }
  ]